import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import { Box, Button, Card, TextField } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { enqueueSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import ConfirmDelete from "../../shared/components/ConfirmDelete";
import CustomDataGrid from "../../shared/components/CustomDataGrid";
import { handleError } from "../../shared/functions/handleError";
import { usePagination } from "../../shared/hooks/usePagination";
import { IUser } from "../../shared/interfaces/user/IUser";
import { useUserColumns } from "./hooks/useUserColumns";
import { UserService } from "./service";

const AdminUser = () => {
  const { t } = useTranslation();
  const [data, setData] = useState<IUser[] | undefined>(undefined);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState<undefined | IUser>(
    undefined,
  );
  const navigate = useNavigate();
  const columns = useUserColumns(setSelectedUser, setShowDeleteModal);
  const {
    pagination,
    count,
    setPagination,
    totalPages,
    setTotalPages,
    handleUpdateList,
    setCount,
    changeFilterHandler,
  } = usePagination({
    perPage: 30,
  });

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
    setSelectedUser(undefined);
  };

  const deleteHandler = (id?: number) => {
    !!id &&
      UserService.delete(id)
        .then(() => {
          handleUpdateList();
          enqueueSnackbar(
            t("toasts.successfullyDeleted", {
              title: selectedUser?.displayName,
            }),
            {
              variant: "success",
            },
          );
          closeDeleteModal();
        })
        .catch(handleError);
  };

  useEffect(() => {
    UserService.get({ ...pagination, page: pagination?.page + 1 })
      .then((response) => {
        setCount(response?.count);
        setTotalPages(Math.ceil(response?.count / response?.perPage));
        setData(response.data);
      })
      .catch(handleError);
  }, [pagination, setTotalPages, setCount]);
  return (
    <Card sx={{ marginTop: "30px" }}>
      <Box
        sx={{
          pb: "20px",
        }}
      >
        <Grid container spacing={2} sx={{ alignItems: "center" }}>
          <Grid size={{ xs: 12, md: 6, lg: 3 }}>
            <TextField
              onChange={(e) => {
                changeFilterHandler("email", e.target.value);
              }}
              label={t("general.searchByEmail")}
              fullWidth
            />
          </Grid>
          <Grid
            size={{ xs: 12, lg: 9 }}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              variant={"contained"}
              onClick={() => navigate("/user/create")}
              sx={{ width: { xs: "100%", lg: "auto" } }}
            >
              <AddCircleOutlineOutlinedIcon sx={{ marginRight: "5px" }} />
              {t("button.addNewUser")}
            </Button>
          </Grid>
        </Grid>
      </Box>
      <CustomDataGrid
        columns={columns}
        rows={data || []}
        rowCount={count}
        setPagination={setPagination}
        pagination={pagination}
        loading={data === undefined}
        hasNextPage={totalPages < pagination?.page}
      />

      <ConfirmDelete
        open={showDeleteModal}
        title={selectedUser?.displayName}
        handleClose={closeDeleteModal}
        handleSubmit={() => deleteHandler(selectedUser?.id)}
      />
    </Card>
  );
};

export default AdminUser;
